export default __webpack_public_path__ + "images/icx_46730b.svg";